import React, { useMemo } from 'react';
import { FormLabel } from '@material-ui/core';
import CheckboxRhf from '../../components/CheckboxRhf';
import { Controller } from 'react-hook-form';
import RadioRhf from '../../components/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../../components/RadioRhf/RadioOptionRhf';
import { IMPRESSION_TYPE } from '../../../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import { archRententionOption, archRententionVeneerShieldOption } from '../../Question';
import { useLang } from '../../../../util/lang';
import { ENABLE_Veneer_Shield_QUESTION } from '../../../../pages/DiffRetainer/utils';

/**
 * 渲染舌侧/腭侧丝处理方式问题，并按保持器类型切换可选项。
 */
const ClearRetainerRhf = ({
    question,
    control,
    errors,
    questionData = { A: {}, B: {} },
    disable,
    formValues,
    impressionType,
    subType = '',
}) => {
    const getDiffRetainerLang = useLang('DiffRetainer');
    const questionA = questionData['A'];
    const questionB = questionData['B'];

    // const enableUpperOpt = useMemo(() => {
    //     return disable ? disable : impressionType === IMPRESSION_TYPE.LOWER
    // },[disable, impressionType])

    // const enableLowerOpt = useMemo(() => {
    //     return disable ? disable : impressionType === IMPRESSION_TYPE.UPPER
    // },[disable, impressionType])

    const hiddenInput = useMemo(() => {
        let hidden = {
            QA: false,
            QB: false,
        };
        // if(!subType || !subType.length) return hidden
        // if no subType means user has selected upper or lower
        if (!subType || !subType.length) {
            if (impressionType !== IMPRESSION_TYPE.UPPER_AND_LOWER) {
                hidden.QA = impressionType === IMPRESSION_TYPE.LOWER;
                hidden.QB = impressionType === IMPRESSION_TYPE.UPPER;
            }
            return hidden;
        }
        hidden.QA = subType === 'Lower';
        hidden.QB = subType === 'Upper';
        return hidden;
    }, [subType, impressionType]);

    const memoQusetionOpt = useMemo(() => {
        const option = questionA?.children?.option || archRententionOption;
        const selectedRetainer =
            subType.length > 0 ? formValues[`${subType}ArchAndQuantity`] : formValues['archAndQuantity'];

        if (ENABLE_Veneer_Shield_QUESTION.includes(selectedRetainer)) {
            return archRententionVeneerShieldOption;
        }

        if (selectedRetainer === 'ecodontRetainersWithWire') {
            return option.filter((opt) => opt.value !== 'virtuallyRemoveLingualOrPalatalWire');
        }
        return option;
    }, [formValues, subType]);

    return (
        <div>
            <FormLabel component={'legend'}>{question}</FormLabel>
            <Controller
                defaultValue={questionA.value}
                rules={{ required: true }}
                control={control}
                name={questionA.name}
                render={({ field }) => {
                    return (
                        <div id={questionA.name} style={{ display: hiddenInput.QA && 'none' }}>
                            {/* <CheckboxRhf {...field} label={questionA.label} control={control} disabled={enableUpperOpt} errors={errors}/> */}
                            {/* <div style={{marginLeft : 50}}> */}
                            <RadioRhf
                                question={''}
                                name={questionA.children.name}
                                control={control}
                                errors={errors}
                                row={false}
                                formControlLabelRhf={
                                    <>
                                        {memoQusetionOpt.map((opt) => {
                                            return (
                                                <RadioOptionRhf
                                                    value={opt.value}
                                                    label={getDiffRetainerLang(`formOptions.${opt.value}`)}
                                                    // disable={!formValues[questionA.name]}
                                                    key={subType ? subType + opt.value : opt.value}
                                                />
                                            );
                                        })}
                                    </>
                                }
                            />
                            {/* </div> */}
                        </div>
                    );
                }}
            />
            <Controller
                defaultValue={questionB.value}
                rules={{ required: true }}
                control={control}
                name={questionB.name}
                render={({ field }) => {
                    return (
                        <div id={questionB.name} style={{ display: hiddenInput.QB && 'none' }}>
                            {/* <CheckboxRhf {...field} label={questionB.label} control={control} disabled={enableLowerOpt} errors={errors}/> */}
                            {/* <div style={{marginLeft : 50}}> */}
                            <RadioRhf
                                question={''}
                                name={questionB.children.name}
                                control={control}
                                errors={errors}
                                row={false}
                                formControlLabelRhf={
                                    <>
                                        {memoQusetionOpt.map((opt) => {
                                            return (
                                                <RadioOptionRhf
                                                    value={opt.value}
                                                    label={getDiffRetainerLang(`formOptions.${opt.value}`)}
                                                    // disable={!formValues[questionB.name]}
                                                    key={subType ? subType + opt.value : opt.value}
                                                />
                                            );
                                        })}
                                    </>
                                }
                            />
                            {/* </div> */}
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default ClearRetainerRhf;
